export default {
    async setStatistics({commit}, statistics) {
      commit('SET_STATISTICS', statistics);
    },
  }
  